module.exports = __webpack_public_path__ + "img/18_102.2358bc06.png";